import { useState, useEffect } from 'react'
import { ArrowRight } from 'lucide-react'
import packageJson from '../../package.json'
import { getImageUrl } from '../utils/apiUrl'

const Maintenance = () => {
  const [maintenanceData, setMaintenanceData] = useState({
    message: 'Site en maintenance. Nous revenons bientôt !',
    banner_image: null
  })

  const currentYear = new Date().getFullYear()
  const appVersion = packageJson.version || import.meta.env.VITE_REACT_APP_VERSION || process.env.REACT_APP_VERSION || ''

  useEffect(() => {
    // Récupérer les données de maintenance depuis l'API
    const fetchMaintenanceData = async () => {
      try {
        const response = await fetch(`${import.meta.env.VITE_API_URL}/settings/public`)
        const data = await response.json()
        
        if (data.maintenance_mode) {
          setMaintenanceData({
            message: data.maintenance_message || 'Site en maintenance. Nous revenons bientôt !',
            banner_image: data.maintenance_banner_image
          })
        }
      } catch (error) {
        console.error('Erreur lors de la récupération des données de maintenance:', error)
      }
    }

    fetchMaintenanceData()
  }, [])

  // Style pour l'image de fond
  const backgroundStyle = maintenanceData.banner_image ? {
    backgroundImage: `url(${getImageUrl(maintenanceData.banner_image)})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat'
  } : {
    background: 'linear-gradient(135deg, #f97316 0%, #ea580c 100%)'
  }

  return (
    <div 
      className="min-h-screen flex items-center justify-center p-4 relative"
      style={backgroundStyle}
    >
      {/* Overlay sombre pour améliorer la lisibilité */}
      <div className="absolute inset-0 bg-black bg-opacity-50"></div>
      
      <div className="max-w-4xl w-full text-center relative z-10">
        {/* Logo par défaut si pas d'image de bannière */}
        {!maintenanceData.banner_image && (
          <div className="mb-8">
            <img 
              src={getImageUrl('/images/logo/flightcase-logo.jpg')}
              alt="Flightcase FWI"
              className="mx-auto h-24 w-auto"
              onError={(e) => {
                e.target.style.display = 'none'
              }}
            />
          </div>
        )}

        {/* Titre */}
        <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
          Site en maintenance
        </h1>

        {/* Message */}
        <p className="text-xl text-white mb-8 max-w-2xl mx-auto leading-relaxed">
          {maintenanceData.message}
        </p>

        {/* Contact */}
        <div className="bg-white bg-opacity-20 backdrop-blur-sm rounded-lg shadow-lg p-6 max-w-2xl mx-auto mb-8">
          <h3 className="text-lg font-semibold text-white mb-3">
            Besoin d'aide urgente ?
          </h3>
          <p className="text-white mb-4">
            Pour toute demande urgente, n'hésitez pas à nous contacter :
          </p>
          <div className="space-y-2 text-white">
            <p>📞 <strong>+590 590 265 430</strong></p>
            <p>✉️ <strong>planning@flightcasefwi.com</strong></p>
          </div>
        </div>

        {/* Bouton de retour (pour les admins) */}
        <div className="mt-8">
          <button
            onClick={() => window.location.reload()}
            className="inline-flex items-center px-6 py-3 bg-white bg-opacity-20 backdrop-blur-sm text-white border border-white border-opacity-30 rounded-lg hover:bg-opacity-30 transition-colors font-medium"
          >
            <ArrowRight className="h-4 w-4 mr-2" />
            Actualiser la page
          </button>
        </div>

        {/* Footer */}
        <div className="mt-12 text-white text-sm opacity-80">
          <p>Flightcase © {currentYear} – {appVersion ? `v${appVersion}` : ''}</p>
        </div>
      </div>
    </div>
  )
}

export default Maintenance
